/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface CourseModuleSettings { 
    /**
     * 
     */
    portfolioTotalHours?: boolean;
    /**
     * 
     */
    portfolioTypes?: Array<string>;
    /**
     * 
     */
    portfolioSource?: CourseModuleSettings.PortfolioSourceEnum;
    /**
     * 
     */
    weeklyScheduleShifts?: boolean;
    /**
     * 
     */
    allowLinks?: boolean;
}
export namespace CourseModuleSettings {
    export type PortfolioSourceEnum = 'user' | 'import';
    export const PortfolioSourceEnum = {
        User: 'user' as PortfolioSourceEnum,
        Import: 'import' as PortfolioSourceEnum
    };
}


